import { render, staticRenderFns } from "./AppPhoneBar.vue?vue&type=template&id=274865f6&scoped=true&"
import script from "./AppPhoneBar.vue?vue&type=script&lang=js&"
export * from "./AppPhoneBar.vue?vue&type=script&lang=js&"
import style0 from "./AppPhoneBar.vue?vue&type=style&index=0&id=274865f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274865f6",
  null
  
)

export default component.exports